import React, { ReactElement } from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const FormOperators = ({disabledFields} : {disabledFields?: boolean}): ReactElement => {
  const { t } = useTranslation('common');

  const { TextArea } = Input;

  return (
    <div>
      <Form.Item label={t('misc.operatorsRegionsAndRoutes')} name='operatorsRegionsAndRoutes'>
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item
        label={t('misc.operatorsTypesOfTrainsVesselsInService')}
        name='operatorsTypesOfTrainsVesselsInService'
      >
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item
        label={t('misc.operatorsParticularTypesOfCargo')}
        name='operatorsParticularTypesOfCargo'
      >
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item label={t('misc.operatorsUniqueSellingPoint')} name='operatorsUniqueSellingPoint'>
        <TextArea disabled={disabledFields} />
      </Form.Item>
      <Form.Item label={t('misc.operatorsAddOnServices')} name='operatorsAddOnServices'>
        <TextArea disabled={disabledFields} />
      </Form.Item>
    </div>
  );
};

export default FormOperators;
